//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    components: {
    },
    props: {},
    data() {
        return {
            selectTab: "first-tab"
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
    }
};
